// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__ZsnIc","col":"styles_col__3-fVD"};